// removed by extract-text-webpack-plugin
module.exports = {"warningContent":"src-node_modules-kts-platform-frame-appSdk-AppResource-WarningContent-index__warningContent--B6dUg","head":"src-node_modules-kts-platform-frame-appSdk-AppResource-WarningContent-index__head--2XlHu","title":"src-node_modules-kts-platform-frame-appSdk-AppResource-WarningContent-index__title--GE7Cv","icon":"src-node_modules-kts-platform-frame-appSdk-AppResource-WarningContent-index__icon--2BVE1","cont":"src-node_modules-kts-platform-frame-appSdk-AppResource-WarningContent-index__cont--2lOh_"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-platform-frame/appSdk/AppResource/WarningContent/index.scss
// module id = 2448
// module chunks = 0